import { createFileRoute } from '@tanstack/react-router';
import FolderIndexPage from '../components/FolderIndexPage';
import { validateListPageSearch } from '../utils/listPageSearch';

export const Route = createFileRoute('/_app/folder/$folderId/$slug/')({
  validateSearch: validateListPageSearch,
  component: FolderIndexPage,
});
